import { Injectable } from '@angular/core';
import { McticHttpClient } from '@mctic/ng-core';
import { FaturamentoAntigoVO } from '../shared/model/faturamento-antigo-vo.model';
import { FaturamentoBrutoVO } from '../shared/model/faturamento-bruto-vo.model';
import { Observable,  } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FaturamentoService {

  private readonly service = '/sepin-backend/rest/faturamentos';
  constructor(private readonly http: McticHttpClient) {
  }

  obterPorFaturamentoProduto(idFaturamentoProduto: number) {
    return this.http.get<FaturamentoAntigoVO>(`/sepin-backend/rest/faturamento-antigo-produtos/${idFaturamentoProduto}/faturamentos`);
  }

  cadastrar(faturamento: FaturamentoAntigoVO) {
    return this.http.post(this.service, faturamento);
  }

  atualizar(faturamento: FaturamentoAntigoVO) {
    return this.http.put(this.service, faturamento);
  }

  obterTotais(): Observable<FaturamentoBrutoVO> {
    return this.http.get<FaturamentoBrutoVO>(`${this.service}/totais`);
  }
}
